@if (message(); as message) {
  @if (
    message.content['msgtype'] === MsgType.Text &&
    clientService.client.getUserId() === message.senderId &&
    !message.isRedacted
  ) {
    <button mat-icon-button (click)="toogleEdit()" matTooltip="Nachricht bearbeiten">
      <mat-icon svgIcon="edit-message"></mat-icon>
    </button>
  }
}
